module.exports = __webpack_public_path__ + "img/btn_back.01786451.svg";